import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid, TextField, MenuItem, FormControl, InputLabel, Select, Button, Avatar } from "@mui/material";
import * as CategoryActions from '../../../redux/actions/categoryAction.js';
import * as SubCategoryActions from '../../../redux/actions/subCategoryAction.js';
import * as SancharActions from '../../../redux/actions/sancharAction';
import logo_icon from '../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { RedirectPageData } from "../../../utils/static-data/index.js";

const AddVideoclip = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { categoryData } = useSelector(state => state.categoryReducer);
  const { subCategoryData, subCatgeoryDataByCategoryId } = useSelector(state => state.subCategoryReducer);
  const redirectCategoryData = categoryData.filter(value => value?.redirect_page === 'Videoclip');   //* Redirect Category Data For Category Name Option

  const [videoclipDetail, setVideoclipDetail] = useState({ categoryId: '', subCategoryId: '', videoclipName: '', link: '', type: '', description: '' });
  const [inputFieldError, setInputFieldError] = useState({ categoryId: '', subCategoryId: '', videoclipName: '', link: '', type: '', description: '', image: '' });
  const [image, setImage] = useState({ file: logo_icon, bytes: "" });
  const [video, setVideo] = useState({ file: null, bytes: "" });
  const [trending, setTrending] = useState(false);

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }))
  }

  //* Handle Input Field : Data
  const handleInputField = (e) => {
    const { name, value } = e.target;
    setVideoclipDetail({ ...videoclipDetail, [name]: value });
  };

  //* Handle Image
  const handleImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0]?.size < 1 * 1024 * 1024) {
        setImage({
          file: URL.createObjectURL(e.target.files[0]),
          bytes: e.target.files[0],
        });
      } else {
        alert("Please upload image having size less than 1 MB")
      }
    }
    handleInputFieldError("image", null)
  };

  //* Handle Video
  const handleVideo = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0]?.size < 1 * 1024 * 1024) {
        setVideo({
          file: URL.createObjectURL(e.target.files[0]),
          bytes: e.target.files[0],
        });
      } else {
        alert("Please upload video having size less than 1 MB")
      }
    }
    handleInputFieldError("video", null);
  };

  //! Handle Validation
  const handleValidation = () => {
    let isValid = true;
    const { videoclipName, categoryId, subCategoryId, description, link, type } = videoclipDetail;
    const { bytes: imageBytes } = image;
    const { bytes: videoBytes } = video;

    if (!categoryId) {
      handleInputFieldError("categoryId", "Please Select Category Name")
      isValid = false;
    }
    if (!subCategoryId) {
      handleInputFieldError("subCategoryId", "Please Select Sub Category Name")
      isValid = false;
    }
    if (!videoclipName) {
      handleInputFieldError("videoclipName", "Please Enter Videoclip Name")
      isValid = false;
    }
    if (type == "video") {
      if (!imageBytes) {
        handleInputFieldError("image", "Please Select Image");
        isValid = false;
      }
      if (!videoBytes) {
        handleInputFieldError("video", "Please Select Video File")
        isValid = false;
      }
    }
    if (type == 'link') {
      if (!link) {
        handleInputFieldError("link", "Please Enter Link")
        isValid = false;
      }
    }

    if (!description) {
      handleInputFieldError("description", "Please Enter Description")
      isValid = false;
    }
    return isValid;
  };

  //! Handle Submit - Creating Videoclip
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      console.log("Videoclip Data :: ", { ...videoclipDetail, trending, image: image?.bytes })
      const { categoryId, subCategoryId, type, videoclipName, link, description, } = videoclipDetail;

      let formData = new FormData()
      formData.append("videoCategoryId", categoryId)
      formData.append("videoSubCategoryId", subCategoryId)
      formData.append("title", videoclipName)
      formData.append("type", type)
      type == 'link' && formData.append("link", link)
      formData.append("description", description);
      formData.append("is_trending", trending);
      type == 'video' && formData.append("image", image?.bytes);
      type == 'video' && formData.append("video", video?.bytes);

      console.log(image?.bytes);
      console.log(video?.bytes);

      const payload = {
        data: formData,
        onComplete: () => navigate("/video-clip")
      }

      //! Dispatching API for Creating Videoclip
      dispatch(SancharActions.createVideoclip(payload));
    }
  };

  useEffect(() => {
    //! Dispatching API for Getting Category
    dispatch(CategoryActions.getCategory())
  }, []);

  useEffect(() => {
    //! Dispatching API for Getting Sub Category
    videoclipDetail?.categoryId && dispatch(SubCategoryActions.getSubCategoryByCategoryId({ categoryId: videoclipDetail?.categoryId }))
  }, [videoclipDetail?.categoryId]);

  return (
    <>
      <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
          <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>Add Videoclip</div>
          <div onClick={() => navigate("/video-clip")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
        </div>

        <Grid container sx={{ alignItems: 'start' }} spacing={3}>
          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Category Name</InputLabel>
              <Select
                label="Select Category Name" variant="outlined" fullWidth
                name='categoryId'
                value={videoclipDetail?.categoryId}
                onChange={handleInputField}
                error={inputFieldError?.categoryId ? true : false}
                onFocus={() => handleInputFieldError("categoryId", null)}
              >
                <MenuItem disabled>---Select Category---</MenuItem>
                {redirectCategoryData.map((value, index) => <MenuItem key={index} value={value?._id}>{value?.category_name}</MenuItem>)}
              </Select>
            </FormControl>
            {inputFieldError?.categoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.categoryId}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Sub Category</InputLabel>
              <Select
                label="Select Sub Category" variant="outlined" fullWidth
                name='subCategoryId'
                value={videoclipDetail?.subCategoryId}
                onChange={handleInputField}
                error={inputFieldError?.subCategoryId ? true : false}
                onFocus={() => handleInputFieldError("subCategoryId", null)}
              >
                {subCatgeoryDataByCategoryId.length == 0 ? <MenuItem disabled>---Please First Select category---</MenuItem> : <MenuItem disabled>---Select Sub Category---</MenuItem>}
                {subCatgeoryDataByCategoryId && subCatgeoryDataByCategoryId.length == 0 ? <MenuItem disabled>You don't have Sub category</MenuItem> : subCatgeoryDataByCategoryId?.map(value => (<MenuItem key={value?._id} value={value?._id}>{value?.sub_category_name}</MenuItem>))}
              </Select>
            </FormControl>
            {inputFieldError?.subCategoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.subCategoryId}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Videoclip Name" variant='outlined' fullWidth
              name='videoclipName'
              value={videoclipDetail?.videoclipName}
              onChange={handleInputField}
              error={inputFieldError.videoclipName ? true : false}
              helperText={inputFieldError.videoclipName}
              onFocus={() => handleInputFieldError("videoclipName", null)}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Type</InputLabel>
              <Select
                label="Select Type" variant="outlined" fullWidth
                name='type'
                value={videoclipDetail?.type}
                onChange={handleInputField}
                error={inputFieldError?.type ? true : false}
                onFocus={() => handleInputFieldError("type", null)}
              >
                <MenuItem disabled>---Please Select Type---</MenuItem>
             
                <MenuItem value={'link'}>Link</MenuItem>
              </Select>
            </FormControl>
            {inputFieldError?.type && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.type}</div>}
          </Grid>

          {videoclipDetail?.type == 'video' && <>
            <Grid item lg={6} sm={6} md={12} xs={12} >
              <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
                <Grid item xs={2} >
                  <Avatar src={image.file} style={{ width: 40, height: 40 }} />
                </Grid>
                <Grid component="label" item xs={10} style={{ backgroundColor: "#E2E8F0", textAlign: "center", color: "#666666", padding: "10px 30px", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                  Upload Videoclip Image
                  <input onChange={handleImage} hidden accept="image/*" type="file" />
                </Grid>
              </Grid>
              {inputFieldError?.image && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.image}</div>}
            </Grid>

            <Grid item lg={6} md={6} xs={12}>
              <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
                <Grid component="label" item xs={12} style={{ padding: "10px", textAlign: "center", color: "#666666", border: "1px solid #C4C4C4", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                  {video?.bytes ? video?.bytes?.name : 'Upload Videoclip'}
                  <input onChange={handleVideo} hidden accept="video/*" type="file" />
                </Grid>
              </Grid>
              {inputFieldError.video && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError.video}</div>}
            </Grid>
          </>}

          {videoclipDetail?.type == 'link' && <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Video Link" variant='outlined' fullWidth
              name='link'
              value={videoclipDetail?.link}
              onChange={handleInputField}
              error={inputFieldError.link ? true : false}
              helperText={inputFieldError.link}
              onFocus={() => handleInputFieldError("link", null)}
            />
          </Grid>}

          <Grid item lg={6} md={6} xs={12} >
            <div style={{ display: "flex", gap: "20px", border: "1px solid #C4C4C4", padding: "14px 13.5px", borderRadius: "5px" }}>
              <label style={{ cursor: "pointer", color: "#666666", fontFamily: "Philosopher", fontSize: "13.5px", color: "#667284" }} htmlFor="layout-template">Trending Videoclip</label>
              <input onClick={(e) => setTrending(e.target.checked)} style={{ cursor: "pointer", marginTop: "0px", padding: "0px" }} id='layout-template' type="checkbox" />
            </div>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12} >
            <TextField
              label="Description" variant='outlined' fullWidth
              name='description'
              value={videoclipDetail?.description}
              onChange={handleInputField}
              error={inputFieldError.description ? true : false}
              helperText={inputFieldError.description}
              onFocus={() => handleInputFieldError("description", null)}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container sx={{ justifyContent: "space-between" }}>
              <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default AddVideoclip;